import { render, staticRenderFns } from "./PlaylistCreateEdit.vue?vue&type=template&id=27a1fab2&scoped=true"
import script from "./PlaylistCreateEdit.vue?vue&type=script&lang=ts"
export * from "./PlaylistCreateEdit.vue?vue&type=script&lang=ts"
import style0 from "./PlaylistCreateEdit.vue?vue&type=style&index=0&id=27a1fab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a1fab2",
  null
  
)

export default component.exports